export const TestIdsPages = {
  HealthPage: 'health-page',
  IncorrectAccountTypePage: 'incorrect-account-type-page',
  VerificationRequiredPage: 'verification-required-page',
};
